/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { PlantConfiguration } from '@poweralpha/common';
import { uniq } from 'lodash';
import * as yup from 'yup';
import * as z from 'zod';

export const realisticDateSchema = yup
  .date()
  .min(new Date('2000-01-01'))
  .max(new Date('2035-01-01'));

export const realisticDateSchemaZ = z
  .date()
  .min(new Date('2000-01-01'))
  .max(new Date('2035-01-01'));

export const multiServiceCodTest = (
  plantConfig: Array<PlantConfiguration>,
  cods: { pv: Date | null; ess: Date | null; fimo: Date | null },
) => {
  const codVals: Array<number> = [];
  if (cods.pv && plantConfig.includes(PlantConfiguration.PV)) {
    codVals.push(cods.pv.valueOf());
  }
  if (cods.ess && plantConfig.includes(PlantConfiguration.BESS)) {
    codVals.push(cods.ess.valueOf());
  }

  if (cods.fimo) {
    // if FIMO, all CODs must match FIMO
    return codVals.filter((v) => v !== cods.fimo?.valueOf()).length === 0;
  }

  // otherwise, just match
  const uniqVals = uniq(codVals);
  return uniqVals.length === 0 || uniqVals.length === 1;
};
